export const manifest = {
  screens: {
    scr_xymmaw: { name: "Choose a number", route: "/forwardingSetup", position: {"x":160,"y":220} },
    scr_o5heaf: { name: "Set up landline forwarding", route: "/forwardingSetup", state: {"selection":"landline"}, position: {"x":1560,"y":220} },
    scr_8aa3gl: { name: "Turn off landline forwarding", route: "/iosDeactivation", state: {"forwardingNumberType":"landline"}, position: {"x":160,"y":2200} },
    scr_00p3sl: { name: "Choose a plan", route: "/planSelection", state: {"selectedPlanId":"starter"}, position: {"x":160,"y":4180} },
    scr_s9nmtu: { name: "Review consent · Trial offer", route: "/subscriptionConsent", state: {"selectedPlanId":"growth","hasTrialOffer":true}, position: {"x":1560,"y":4180} },
    scr_pnbmnu: { name: "Enter payment details · Trial offer", route: "/proCheckout", state: {"selectedPlanId":"scale","hasTrialOffer":true}, position: {"x":2960,"y":4180} },
    scr_7kg3bq: { name: "Review consent · No trial", route: "/subscriptionConsent", state: {"selectedPlanId":"growth","hasTrialOffer":false}, position: {"x":4360,"y":4180} },
    scr_d3jj3l: { name: "Enter payment details · No trial", route: "/proCheckout", state: {"selectedPlanId":"scale","hasTrialOffer":false}, position: {"x":5760,"y":4180} },
    scr_acmg6s: { name: "Home · First-time user", route: "/home", state: {"homeState":"firstTime"}, position: {"x":160,"y":6160} },
    scr_9o6ipw: { name: "Home · Call answering off", route: "/home", state: {"homeState":"inactive"}, position: {"x":4360,"y":6160} },
    scr_zadfp5: { name: "Home · Answering active", route: "/home", state: {"homeState":"active"}, position: {"x":7160,"y":6160} },
    scr_q2rt1r: { name: "Home · Partially active", route: "/home", state: {"homeState":"partial"}, position: {"x":5760,"y":6160} },
    scr_i7q5x6: { name: "Home · Setup incomplete", route: "/home", state: {"homeState":"incomplete"}, position: {"x":1560,"y":6160} },
    scr_relpvr: { name: "Home · Needs attention", route: "/home", state: {"homeState":"attention"}, position: {"x":8560,"y":6160} },
    scr_y77kgv: { name: "Meetings booked", route: "/bookings", position: {"x":160,"y":8140} },
  },
  sections: {
    sec_z4jcuz: { name: "Landline forwarding setup", x: 0, y: 0, width: 2920, height: 1180 },
    sec_5vb9lw: { name: "Landline forwarding deactivation", x: 0, y: 1980, width: 1520, height: 1180 },
    sec_0yf0ak: { name: "Subscription checkout", x: 0, y: 3960, width: 7120, height: 1180 },
    sec_ja8aln: { name: "Home screen states", x: 0, y: 5940, width: 9920, height: 1180 },
    sec_7qfiqn: { name: "Meeting bookings", x: 0, y: 7920, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_z4jcuz", children: [
      { kind: "screen", id: "scr_xymmaw" },
      { kind: "screen", id: "scr_o5heaf" },
    ] },
    { kind: "section", id: "sec_5vb9lw", children: [
      { kind: "screen", id: "scr_8aa3gl" },
    ] },
    { kind: "section", id: "sec_0yf0ak", children: [
      { kind: "screen", id: "scr_00p3sl" },
      { kind: "screen", id: "scr_s9nmtu" },
      { kind: "screen", id: "scr_pnbmnu" },
      { kind: "screen", id: "scr_7kg3bq" },
      { kind: "screen", id: "scr_d3jj3l" },
    ] },
    { kind: "section", id: "sec_ja8aln", children: [
      { kind: "screen", id: "scr_acmg6s" },
      { kind: "screen", id: "scr_i7q5x6" },
      { kind: "screen", id: "scr_9o6ipw" },
      { kind: "screen", id: "scr_q2rt1r" },
      { kind: "screen", id: "scr_zadfp5" },
      { kind: "screen", id: "scr_relpvr" },
    ] },
    { kind: "section", id: "sec_7qfiqn", children: [
      { kind: "screen", id: "scr_y77kgv" },
    ] },
  ],
}
